import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SiteLayout from "@/components/layout/SiteLayout";
import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import WorkPage from "@/pages/WorkPage";
import ProjectDetailPage from "@/pages/ProjectDetailPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import AdminPage from "@/pages/AdminPage";
import NotFoundPage from "@/pages/NotFoundPage";
import AnalyticsRouteListener from "@/components/shared/AnalyticsRouteListener";
import CookieConsent from "@/components/shared/CookieConsent";
import { bootAnalytics } from "@/lib/analytics";

function App() {
    useEffect(() => {
        // Re-assert stored consent state against Consent Mode v2 on every
        // page load. Lazily loads gtag.js only if the visitor previously
        // granted analytics consent AND is not opted out AND current route
        // is public. Otherwise this is a no-op — no external script is
        // requested and no measurement traffic is generated.
        bootAnalytics();
    }, []);

    return (
        <div className="App dark">
            <div className="noise-overlay" aria-hidden="true" />
            <BrowserRouter>
                <AnalyticsRouteListener />
                <Routes>
                    <Route element={<SiteLayout />}>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/services" element={<ServicesPage />} />
                        <Route path="/work" element={<WorkPage />} />
                        <Route path="/work/:slug" element={<ProjectDetailPage />} />
                        <Route path="/about" element={<AboutPage />} />
                        <Route path="/contact" element={<ContactPage />} />
                        <Route path="/privacy" element={<PrivacyPage />} />
                        <Route path="/terms" element={<TermsPage />} />
                        <Route path="*" element={<NotFoundPage />} />
                    </Route>
                    <Route path="/admin" element={<AdminPage />} />
                </Routes>
                <CookieConsent />
            </BrowserRouter>
            <Toaster
                position="top-right"
                theme="dark"
                toastOptions={{
                    style: {
                        background: "#0B0C10",
                        border: "1px solid rgba(255,255,255,0.12)",
                        color: "#F2F1ED",
                    },
                }}
            />
        </div>
    );
}

export default App;
